import { createSelector } from 'reselect';
import UserStore from '../../../../stores/UserStore';

const postbacks = (state) => state.postbacks.list.data;

export const getListPostbacks = createSelector(
    postbacks,
    (postbacks = []) => {
        return postbacks;
    }
);

export const getHeaderNames = createSelector(
    () => {
        const staticNamesPage = UserStore.getTranslation().postbackPage.list;
        const tipsNames = UserStore.getTranslation().dataTable.headers;

        return [
            '#',
            staticNamesPage.table.name,
            staticNamesPage.table.url,
            staticNamesPage.table.method,
            staticNamesPage.table.conversionStatuses,
            staticNamesPage.table.goalActionIds,
            tipsNames.actions
        ];
    }
);
